import { useEffect, useState } from "react";

import moment from "moment";
import { CheckListModal } from "./CheckListModal";
import { useDispatch, useSelector } from "react-redux";
import { useAuthState } from "../../../../../Helper/Context";
import { DailyWorkChecklistProgressWiseEmployeeAPI } from "../../../../../Redux/DailyWorkChecklistProgress/EmployeeWiseProgress/EmployeeWiseProgressSlice";
import { Loading } from "../../../../../Helper/Loading";

export const VisitTargetWeekModal = (props) => {
  const { ApiFlag, handleCloseModal, officerData, weekID, FinancialYear, M_AssetTypeID, WorkType } =
    props;
  const { m_WardID, m_UserID } = officerData;
  const userDetails = useAuthState();
  const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
  const { UserID, token } = userDetails.user;
  const dispatch = useDispatch();
  const [checklistModal, setCehcklistModal] = useState(false);
  const [ChecklistData, setChecklistData] = useState(null);
  const [type, setType] = useState("");
  const [flag, setFlag] = useState("")


  const handleOpenChecklistModal = (data, type) => {
    // console.log(data)
    if (weekID === 1) {
      if (type == "complete") {
        setFlag("CompleteChecklist_Week1")
      } else {
        setFlag("Checklist_Week1")
      }
    } else if (weekID === 2) {
      if (type == "complete") {
        setFlag("CompleteChecklist_Week2")
      } else {
        setFlag("Checklist_Week2")
      }
    } else if (weekID === 3) {
      if (type == "complete") {
        setFlag("CompleteChecklist_Week3")
      } else {
        setFlag("Checklist_Week3")
      }
    } else if (weekID === 4) {
      if (type == "complete") {
        setFlag("CompleteChecklist_Week4")
      } else {
        setFlag("Checklist_Week4")
      }
    } else if (weekID === 5) {
      if (type == "complete") {
        setFlag("CompleteChecklist_Week5")
      } else {
        setFlag("Checklist_Week5")
      }
    }
    else if (weekID == 0) {
      if (type == "complete") {
        setFlag("CompleteChecklistTotal")
      } else if (type == "total") {
        setFlag("ChecklistTotal")
      }
    }

    if (type == "complete") {
      setType(type)
    } else {
      setType("")
    }

    setChecklistData(data);

    setCehcklistModal(true);
  };
  const handleCloseChecklistModal = () => {
    setCehcklistModal(false);
  };
  console.log()

  useEffect(() => {
    const data = {
      M_FinancialYearID: year.ID,
      M_MonthID: Month.ID,
      M_ZoneID: 0,
      M_WardID: m_WardID || 0,
      M_AssetTypeID: M_AssetTypeID,
      M_WorkTypeID: WorkType.ID,
      M_OfficerID: m_UserID || 0,
      M_WeekID: weekID,
      M_UserID: UserID,
      Flag: ApiFlag,
      token: token,
    };
    dispatch(DailyWorkChecklistProgressWiseEmployeeAPI({ data }));
  }, [weekID, year.ID, Month.ID, WorkType.ID]);

  const { tableData, isLoading } = useSelector(
    (state) => state.DailyWorkChecklistProgressWiseEmployeeSliceData
  );

  return (
    <>

      <div
        className="modal fade show zIndex"
        style={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "#00000090",
        }}
      >
        <div
          className="modal-dialog modal-dialog-scrollable modal-xl"
          role="document"
        >
          <div
            className="modal-content  p-3"
            style={{ height: "75vh", width: "90vw" }}
          >
            <div className="modal-header py-2">
              <h5 className="card-title heading_modal font">Assets List</h5>
              <button onClick={() => handleCloseModal()} type="button" className="btn-close mr-3 mt-2 " data-dismiss="modal" aria-label="Close" data-backdrop='static' style={{ color: 'white' }} />

            </div>
            {isLoading && <Loading />}
            <div className="modal-body w-100 mx-0 py-0 ">
              <div className="row  pb-4 ">
                <div className="col-12 mb-3">
                  <table id="" className="table table-bordered mb-1">
                    <thead className="" id="" >
                      <tr className="text-center">
                        <th className="text-center fw-bold fs-6 " style={{ width: "4em", background: '#048a8b' }}>Sr. No.</th>
                        <th className="text-center fw-bold fs-6 " style={{ width: "5em", background: '#048a8b' }}>Date</th>
                        <th className="text-center fw-bold fs-6 " style={{ width: "5em", background: '#048a8b' }}>Day</th>
                        <th className="text-center fw-bold fs-6 " style={{ background: '#048a8b' }}>Asset Type</th>
                        <th className="text-center fw-bold fs-6 " style={{ background: '#048a8b' }}>Asset Name</th>
                        {ApiFlag === "Achievement" && <th className="text-center fw-bold fs-6 " style={{ width: "11em", background: '#048a8b' }}>Targeted Checklist</th>}
                        <th className="text-center fw-bold fs-6 " style={{ width: "11em", background: '#048a8b' }}>{`${ApiFlag === "Achievement" ? "Completed Checklist" : "Checklist"}`}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tableData ?
                        tableData.map((i) => (
                          <tr key={i?.rowNum}>
                            <td className="text-center">{i?.rowNum ? i?.rowNum : "-"}</td>
                            <td className="text-center" style={{ width: '12%' }}>{moment(i?.startDate).format('YYYY-MM-DD')}</td>
                            {/* <td className="text-center">-</td> */}
                            <td className="text-center">{i?.m_WeekDays ? i?.m_WeekDays : "-"}</td>
                            <td className="text-center">{i?.assetTypeName ? i?.assetTypeName : "-"}</td>
                            <td>{i?.assetName ? i?.assetName : "-"}</td>
                            {ApiFlag === "Achievement" ?
                              <>
                                <td onClick={() => { handleOpenChecklistModal(i, "total") }} className="text-center cursor-pointer"><span style={{ padding: '5px', background: 'lightgray' }}>{i?.visitTarget ? i?.visitTarget : "-"}</span></td>
                                <td onClick={() => { handleOpenChecklistModal(i, "complete") }} className="text-center cursor-pointer"><span style={{ padding: '5px', background: 'lightgray' }}>{i?.achievement ? i?.achievement : "-"}</span></td></>

                              : <td onClick={() => { handleOpenChecklistModal(i, "total") }} className="text-center" style={{ cursor: "pointer" }}><span style={{ padding: '5px', background: 'lightgray', }}>{i?.totalCheckListCount ? i?.totalCheckListCount : "-"}</span></td>}

                          </tr>
                        )) :
                        <tr>
                          <td colSpan={7}>No Data Found</td>
                        </tr>}


                    </tbody>
                  </table>
                </div>
              </div>
              {/* <div className="row pb-2">
                <div className="col-12 pt-0 text-center">
                  <button
                    onClick={() => { handleCloseModal() }}
                    id="Event_Cancel"
                    type="button"
                    className="bg-danger text-white fs-5 border-1 border-black rounded" >
                    Close
                  </button>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      {checklistModal && (
        <CheckListModal
          M_FinancialYearID={year.ID}
          M_MonthID={Month.ID}
          type={type}
          ChecklistData={ChecklistData}
          handleCloseChecklistModal={handleCloseChecklistModal}
          weekID={weekID}
          Flag={flag}
          WorkType={WorkType}
        />
      )}
    </>
  );
};
